// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuDrawer_container__3hLRr","fadeIn":"MenuDrawer_fadeIn__1hObQ"};